import { removeStylesUrl, removeStylesInHead, replaceStylesLink, replaceStylesInHead } from '../helpers/AppendToHead';

const updateStyle = ({ stylesUrl, styles, isUsingInlineStyles }) => {
    if (stylesUrl && !isUsingInlineStyles) {
        replaceStylesLink(stylesUrl, () => {
            removeStylesInHead();
        });
    } else if (styles) {
        removeStylesUrl();
        replaceStylesInHead(styles);
    }
};

export const switchStyle = store => next => (action) => {
    if (action.type === 'DATA_REPLACEMENT') {
        const isStyleUpdate = action.payload.key === 'customizations';

        if (isStyleUpdate) {
            updateStyle(action.payload.value);
        }
    }

    if (action.type === 'DATA_REQUEST_SUCCESS') {
        const isStyleUpdate = !!action.payload.customizations;

        if (isStyleUpdate) {
            updateStyle(action.payload.customizations);
        }
    }

    return next(action);
};
